module.exports = __webpack_public_path__ + "media/images/players/ORTIZ_CARLOS-e75544811dfb87239adb704a86cd6bf0.png";